<template>
  <div class="user-container">
    <h2>用户管理</h2>
    <div class="content">
      这里是用户管理页面的内容
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserManagement'
}
</script>

<style lang="scss" scoped>
.user-container {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
  
  .content {
    margin-top: 20px;
  }
}
</style>